/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import { isWindow } from './isWindow';

/**
 * Configures webpack public path in a webpack bundle
 *
 * Supports apps loaded using the legacy AppLoader or the new x-runtime & x-shell
 */
export function publicPath(appId: string): string {
    // x-runtime & x-shell resolution. window.xPublicPaths are automatically cleared from window once accessed so there are no permanent side effects
    let path = isWindow() && window.xPublicPaths && window.xPublicPaths[appId];
    if (typeof path !== 'string') {
        // Legacy AppLoader resolution
        const config = isWindow() && window.__nabxAppLoader__ && window.__nabxAppLoader__.getConfig(appId);
        if (config) {
            path = config.manifest.slice(0, config.manifest.lastIndexOf('/') + 1);
        }
    }
    if (isWindow() && path) {
        if (typeof __webpack_public_path__ !== 'undefined') {
            __webpack_public_path__ = path;
        }

        // Note this doesn't actually work in the consuming bundle but I've left it here to guarantee backward compatibility for any un-known consumers
        window.__webpack_public_path__ = path;
    }

    return typeof __webpack_public_path__ !== 'undefined' ? __webpack_public_path__ : path;
}
